import { ACTION_TYPE } from './action';

// region Reducer
const storeVisitStatus = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPE.CALL_API_GET_STORE_VISIT_STATUS_SELECT_SUCCESS:
      return {
        ...state,
        selects: action.selects,
      };
    case ACTION_TYPE.CALL_API_GET_STORE_ALL_VISIT_STATUS_SUCCESS:
      return {
        ...state,
        allDatas: action.datas,
      };
    case ACTION_TYPE.CALL_API_GET_STORE_TAX_VISIT_STATUS_SUCCESS:
      return {
        ...state,
        taxDatas: action.datas,
      };
    case ACTION_TYPE.CALL_API_GET_STORE_AGE_VISIT_STATUS_SUCCESS:
      return {
        ...state,
        ageDatas: action.datas,
      };
    case ACTION_TYPE.CALL_API_GET_STORE_GENDER_VISIT_STATUS_SUCCESS:
      return {
        ...state,
        genderDatas: action.datas,
      };
    default:
      return state;
  }
};

export default storeVisitStatus;
